// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1eaJr","content":"GlobalSearch_content__1YhX2"};